import React, { useEffect, useState } from 'react'
import { formatMessage } from 'lib/intl'
import NestedList from 'components/common/Form/NestedList'
import {
  STATUS_COMPLETED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_STARTED,
} from 'helpers/jobs'

function CreatorsFilter({
  creatorList,
  selectedCreators,
  triggerRules,
  selectedTriggerRules,
  setCreatedBy,
}) {
  const [data, setData] = useState([])

  const formatData = creators =>
    creators.map(({ type, id, listItems, selectedListItems }, index) => {
      const checkParentStatus = () => {
        if (listItems.length) {
          if (selectedListItems.length === listItems.length) {
            return STATUS_COMPLETED
          }

          if (
            selectedListItems.some(item =>
              listItems.find(listItem => listItem.id === item),
            )
          ) {
            return STATUS_IN_PROGRESS
          }
        }

        return STATUS_NOT_STARTED
      }
      const childData = []
      listItems.forEach((item, indexItem) => {
        const checkChildStatus = () => {
          if (selectedListItems.length && selectedListItems.includes(item.id)) {
            return STATUS_COMPLETED
          }

          return STATUS_NOT_STARTED
        }
        childData.push({
          id: item.id,
          name: item.name,
          key: `${type}_${item.id}`,
          type,
          index: indexItem,
          level: 'second',
          selected: checkChildStatus(),
          parentId: id,
        })
      })

      return {
        id,
        index,
        key: `${type}_parent`,
        type: `${type}_parent`,
        childData,
        level: 'first',
        name: formatMessage(type),
        selected: checkParentStatus(),
      }
    })

  useEffect(() => {
    const newData = []
    if (creatorList && creatorList.length) {
      newData.push({
        type: 'users',
        id: 1,
        listItems: creatorList,
        selectedListItems: selectedCreators,
      })
    }
    if (triggerRules && triggerRules.length) {
      newData.push({
        type: 'trigger_rules',
        id: 2,
        listItems: triggerRules,
        selectedListItems: selectedTriggerRules,
      })
    }
    setData(formatData(newData))
  }, [
    JSON.stringify(triggerRules),
    JSON.stringify(selectedTriggerRules),
    JSON.stringify(creatorList),
    JSON.stringify(selectedCreators),
  ])

  return (
    <NestedList
      selectView
      data={data}
      setData={setCreatedBy}
      inputLabel={formatMessage('creators')}
    />
  )
}

export default CreatorsFilter
